import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import KelolaProfil from "./kelola/Profil";
import KelolaStrukturOrganisasi from "./kelola/Anggota";
import KelolaTestimonial from "./kelola/Testimonial";
import KelolaBerita from "./kelola/Berita";
import {
  BuildingOffice2Icon,
  UserGroupIcon,
  ChatBubbleLeftRightIcon,
  NewspaperIcon,
} from "@heroicons/react/24/outline";

// Konfigurasi tab
const tabs = [
  { id: "profil", label: "Profil Perusahaan", icon: BuildingOffice2Icon, component: <KelolaProfil /> },
  { id: "struktur", label: "Struktur Organisasi", icon: UserGroupIcon, component: <KelolaStrukturOrganisasi /> },
  { id: "testimonial", label: "Testimonial", icon: ChatBubbleLeftRightIcon, component: <KelolaTestimonial /> },
  { id: "berita", label: "Berita", icon: NewspaperIcon, component: <KelolaBerita /> },
];

export default function KelolaUtama() {
  const [activeTab, setActiveTab] = useState(tabs[0].id);

  return (
    <div className="w-full h-full p-4 sm:p-6 bg-white/60 backdrop-blur-xl rounded-2xl shadow-lg border border-white/50 flex flex-col">
      
      {/* Header */}
      <div className="mb-6">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-800">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-teal-500">
            Kelola Konten
          </span>{" "} Website
        </h2>
        <p className="text-sm text-gray-600 mt-1">Pilih menu untuk mengubah konten halaman utama.</p>
      </div>

      {/* Navigasi Tab */}
      <div className="flex flex-col sm:flex-row w-full space-y-1 sm:space-y-0 sm:space-x-1 bg-green-900/5 p-1.5 rounded-xl mb-6">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`relative w-full flex items-center justify-start sm:justify-center gap-2 px-4 py-2.5 text-sm font-semibold transition
                ${activeTab === tab.id ? "text-green-800" : "text-gray-600 hover:text-green-700 hover:bg-white/40"}`}
            >
              {activeTab === tab.id && (
                <motion.span
                  layoutId="kelola-active-pill"
                  className="absolute inset-0 z-0 bg-white shadow-md rounded-lg"
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                />
              )}
              <span className="relative z-10 flex items-center gap-2">
                <Icon className="w-5 h-5"/>
                <span>{tab.label}</span>
              </span>
            </button>
          )
        })}
      </div>

      {/* Konten Tab */}
      <div className="flex-1 mt-4">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -15 }}
            transition={{ duration: 0.25 }}
          >
            {tabs.find(tab => tab.id === activeTab)?.component}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
